<script lang="ts">
  import { storyblokEditable, StoryblokComponent } from '@storyblok/svelte';
  import { Grid, GridItem } from '@athena-lib/Grid';
  import { Carousel, CarouselItem } from '@athena-lib/Carousel';
  import clsx from 'clsx';
  import { PageSection } from '@athena-lib/Page';
  import { Stack, StackItem } from '@athena-lib/Stack';
  import type { MaybeResponsive } from '@athena-lib/responsive-utils';
  import type { PageSectionBackground } from '@athena-lib/container-context.svelte';
  import type { CollagePageSectionBlock } from '@storyblok-types';
  import PageSectionHeading from '../shared/PageSectionHeading.svelte';
  import { isRichTextEmpty } from '../../RichText/types';
  import { getGridItemSpansPerLayout, type Layout } from './utils';
  const { blok }: { blok: CollagePageSectionBlock } = $props();
  const layout: Layout = $derived(blok.layout ?? '2');

  const responsiveBackground: MaybeResponsive<PageSectionBackground> = $derived({
    lg: blok.desktopBackgroundColor ?? 'light',
    md: blok.desktopBackgroundColor ?? 'light',
    sm: blok.mobileBackgroundColor ?? 'light',
  });

  const gridItemSpansPerLayout = $derived(getGridItemSpansPerLayout(blok.reverseLayout ?? false));
</script>

<PageSection
  id={blok.elementId}
  action={storyblokEditable}
  actionArg={blok}
  ySpace={{ top: blok.topPadding ?? 'medium', bottom: blok.bottomPadding ?? 'medium' }}
  backgroundColor={responsiveBackground}
>
  <Stack space="large">
    {#if blok.headingText || !isRichTextEmpty(blok.description)}
      <StackItem>
        <PageSectionHeading
          headingText={blok.headingText}
          headingTag={blok.headingTag}
          headingSize={blok.headingSize}
          description={blok.description}
          mobileAlignment={blok.mobileAlignment}
          desktopAlignment={blok.desktopAlignment}
        />
      </StackItem>
    {/if}
    <StackItem>
      {#if blok.swipeInMobile}
        <div class="md:hidden">
          <Carousel peekNext={true} itemCount={parseInt(layout)}>
            {#each Array.from({ length: parseInt(layout) }) as _, index}
              {#if (blok.images ?? [])[index]}
                <CarouselItem class="aspect-square">
                  <StoryblokComponent blok={blok.images![index]} />
                </CarouselItem>
              {/if}
            {/each}
          </Carousel>
        </div>
      {/if}
      <div class={blok.swipeInMobile ? 'hidden md:block' : ''}>
        <Grid columns={12} space="gutter">
          {@const layoutInt = parseInt(layout)}
          {#each Array.from({ length: layoutInt }) as _, index}
            {@const imageSizeMobile =
              blok.largeFirstImageInMobile && index === 0
                ? 12
                : blok.largeFirstImageInMobile &&
                    ((layoutInt === 2 && index == 1) || (layoutInt === 4 && index === 3))
                  ? 12
                  : 6}
            <GridItem
              colSpan={{
                sm: imageSizeMobile,
                md: gridItemSpansPerLayout[layout].colSpan[index],
              }}
              rowSpan={{ sm: 1, md: gridItemSpansPerLayout[layout].rowSpan?.[index] ?? 1 }}
              class={clsx(
                'aspect-square h-full',
                gridItemSpansPerLayout[layout].aspectClass[index],
              )}
            >
              {#if (blok.images ?? [])[index]}
                <StoryblokComponent blok={blok.images![index]} />
              {/if}
            </GridItem>
          {/each}
        </Grid>
      </div>
    </StackItem>
  </Stack>
</PageSection>
